import React from 'react';
import './App.css';
import Form from './ContactForm';
import Topbar from './Topbar';
import Footer from './Footer';
import Map from './GoogleMap';
import { AnimatePresence, motion } from 'framer-motion';

class Contact extends React.Component {

    render() {
        return (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <div className="contact-container">
                    <Form />
                    <div>
                        <div className="contact-info-container">
                            <div className="contact-info">Phone: 647-457-2566</div>
                            <div className="contact-info">Email: info@talltreepsychotherapy.ca</div>
                        </div>
                    </div>
                </div>
            </motion.div>
        )
    }
}

export default Contact;

/*
<div>
                        <Map />
                        <div className="contact-info-container">
                        <div className="contact-info">Office Address:</div>
                        <div className="contact-info">2300 Yonge Street, Suite 1600</div>
                        <div className="contact-info">Toronto, ON M4P 1E4</div>
                        <br />
                        <div className="contact-info">Phone: 416-995-8006</div>
                        <div className="contact-info">Email: info@talltreepsychotherapy.ca</div>
                        <br />
                        <div className="contact-info">Office located on the northwest corner of Yonge St and Eglinton Ave</div>
                        <div className="contact-info">Accessible by TTC subway and bus (Eglinton Station)</div>
                        <div className="contact-info">Paid parking available </div>
                        </div>
                    </div>
                    */